<template>
  <div
    v-tooltip="{
      content: parsedLastMessage,
      delay: { show: 1200, hide: 0 },
      placement: `bottom-${rtl ? 'end' : 'start'}`,
    }"
    class="overflow-hidden text-ellipsis whitespace-nowrap flex items-center gap-[5px]"
  >
    <span
      v-if="message.content"
      class="min-w-0 text-sm/[20px] flex items-center gap-1"
    >
      <template v-if="parsedSubject.length > 0">
        <span v-dompurify-html="parsedSubject" class="font-semibold shrink-0" />
        <span class="shrink-0">-</span>
      </template>
      <template v-if="showMessageType">
        <span
          v-if="isMessagePrivate"
          class="material-symbols-outlined text-base/[16px] text-gray-500"
        >
          draft
        </span>
        <span
          v-else-if="messageByAgent"
          class="material-symbols-outlined text-base/[16px] text-gray-500"
        >
          reply
        </span>
        <span
          v-else-if="isMessageAnActivity"
          class="material-symbols-outlined text-base/[16px] text-gray-500"
        >
          info
        </span>
      </template>
      <span
        v-dompurify-html="parsedLastMessage"
        class="message-content overflow-hidden text-ellipsis whitespace-nowrap"
      />
    </span>
    <span
      v-else-if="message.attachments"
      class="flex items-center gap-1 text-sm/[20px]"
    >
      <span
        v-if="attachmentIcon && showMessageType"
        class="material-symbols-outlined text-base/[16px]"
      >
        {{ attachmentIcon }}
      </span>
      {{ $t(`${attachmentMessageContent}`) }}
    </span>
    <span v-else>
      {{ defaultEmptyMessage || $t('CHAT_LIST.NO_CONTENT') }}
    </span>
  </div>
</template>

<script>
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import messageFormatterMixin from 'shared/mixins/messageFormatterMixin';
import localeMixin from 'shared/mixins/localeMixin';

const ATTACHMENT_ICONS = {
  image: 'image',
  audio: 'headphones',
  video: 'video_camera_back',
  file: 'draft',
  location: 'location_on',
  fallback: 'link',
};

export default {
  name: 'MessagePreview',
  mixins: [messageFormatterMixin, localeMixin /* d99d */],
  props: {
    message: {
      type: Object,
      required: true,
    },
    showMessageType: {
      type: Boolean,
      default: true,
    },
    defaultEmptyMessage: {
      type: String,
      default: '',
    },
    additionalAttributes: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    subject() {
      const { content_attributes: contentAttributes } = this.message;
      const { email: { subject } = {} } = contentAttributes || {};

      return this.additionalAttributes?.mail_subject || subject;
    },
    messageByAgent() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },
    isMessageAnActivity() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.ACTIVITY;
    },
    isMessagePrivate() {
      const { private: isPrivate } = this.message;
      return isPrivate;
    },
    parsedLastMessage() {
      return this.formatMessage(
        this.message.content,
        false,
        true,
        true
      ).replace(/<\/?[^>]+>/gi, ' ');
    },
    parsedSubject() {
      return this.formatMessage(this.subject, false, true, true).replace(
        /<\/?[^>]+>/gi,
        ' '
      );
    },

    lastMessageFileType() {
      const [{ file_type: fileType } = {}] = this.message.attachments;
      return fileType;
    },
    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },
    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },
  },
};
</script>
<style lang="scss" scoped>
.message-content {
  @apply text-gray-500;
}
</style>
